import axios from "axios";

import type { UserBrain } from "@virtual-brain-lib/types";

import env from "../environments";

export const deleteUserBrain = async ({ userBrainId }: { userBrainId: string }) => {
	await axios.delete(`${env.apiUrl}/users-brains/${userBrainId}`);
};

export const createUserBrain = async ({
	userId,
	brainId,
	readOnly,
}: {
	userId: string;
	brainId: string;
	readOnly: boolean;
}) => {
	const response = await axios.post<UserBrain>(`${env.apiUrl}/users-brains`, {
		userId,
		brainId,
		readOnly,
	});

	return response.data;
};

export const updateUserBrain = async ({
	userBrainId,
	readOnly,
}: {
	userBrainId: string;
	readOnly: boolean;
}) => {
	await axios.put(`${env.apiUrl}/users-brains/${userBrainId}`, {
		readOnly,
	});
};
